<div class="wrapper">

@if(order$ | async; as order) {
        <div class="main">
            <hgroup>
                <h1>
                    <app-svg use="basket"></app-svg>
                    <span>{{ 'INVOICE.TITLE' | translate }}</span>
                </h1>
                <p class="disclaimer">{{ 'INVOICE.DISCLAIMER' | translate: {email:order?.billingAddress.email} }}</p>
            </hgroup>
            <div class="order-info">
                <span>{{ 'INVOICE.ORDERNUMBER' | translate:{ordernumber:order?.orderNumber??'N/A'} }}</span>
                <time>{{ 'INVOICE.DATE' | translate:{date:(order.created | date: 'dd/MM-YYYY')} }}</time>
            </div>
            <section class="address-section">
                @if(order?.billingAddress; as address) {
                    <div class="billing-address">
                        <span class="title">{{ 'INVOICE.BILLING_ADDRESS_TITLE' | translate }}</span>
                        <div>
                        @if(address?.organizationName?.length > 0 ) {
                            <span>{{ address?.organizationName }}</span>
                            <span>{{ 'INVOICE.ADDRESS_ATT_LABEL'  | translate:{firstName:address?.firstName ?? '', lastName:address?.lastName ?? ''} }}</span>
                        } @else {
                            <span>{{ 'INVOICE.ADDRESS_NAME_LABEL' | translate:{firstName:address?.firstName ?? '', lastName:address?.lastName ?? ''} }}</span>
                        }
                        <span>{{ address?.line1 }}</span>
                        <span>{{ address?.postalCode }} {{ address?.city }}</span>
                        <span class="email">{{ address?.email }}</span>
                        <span class="phone">{{ 'INVOICE.ADDRESS_PHONE_LABEL' | translate: {phoneNumber:address?.phoneNumber ?? ''} }}</span>
                        @if(order?.cvr?.length > 0) {
                            <span>{{ 'INVOICE.ADDRESS_CVR' | translate: {id:order?.cvr}  }}</span>
                        }
                        @if(order?.gln?.length > 0) {
                            <span>{{ 'INVOICE.ADDRESS_GLN' | translate: {id:order?.gln}  }}</span>
                        }
                        @if(order?.invoiceDetail != null) {
                            @if(order?.invoiceDetail?.referenceNumber != null) {
                                <span>{{ 'INVOICE.ADDRESS_REFERNCE' | translate: {id:order?.invoiceDetail.referenceNumber}  }}</span>
                            }
                            @for (email of (order?.invoiceDetail?.emails??[]); track $index) {
                                <span>{{ 'INVOICE.ADDRESS_REFERNCE_EMAIL' | translate: {email:email}  }}</span>
                            }
                        }
                        <span class="note">{{ order.note }}</span>
                    </div>
                    </div>
                }
                @for(shipment of order.shipments; track $index) {
                    @if((shipment?.shippingMethodType  | lowercase) == 'clickcollect') {
                        <div class="shipping-address">
                            <span class="title">{{ 'INVOICE.SHIPPING_ADDRESS_TITLE' | translate }}</span>
                            <div>
                            <span>{{ order?.shippingAddress?.organizationName }}</span>
                            <span>{{ (order?.shippingAddress?.organizationName?.length > 0 ? 'INVOICE.ADDRESS_ATT_LABEL' : 'INVOICE.ADDRESS_NAME_LABEL') | translate:{firstName:order?.shippingAddress?.firstName ?? '', lastName:order?.shippingAddress?.lastName ?? ''} }}</span>
                            <span>{{ order?.shippingAddress?.line1 }}</span>
                            <span>{{ order?.shippingAddress?.postalCode }} {{ order?.shippingAddress?.city }}</span>
                            <span class="email">{{ order?.shippingAddress?.email }}</span>
                        </div>
                        </div>
                    } @else if((shipment?.shippingMethodType  | lowercase) == 'pickup'){
                        <div class="shipping-address">
                            <span class="title">{{ 'INVOICE.SHIPPING_ADDRESS_TITLE' | translate }}</span>
                            <div>

                                <span>{{ shipment?.pickupPointAddress?.organizationName }}</span>
                                <span>{{ (shipment?.pickupPointAddress?.organizationName?.length > 0 ? 'INVOICE.ADDRESS_ATT_LABEL' : 'INVOICE.ADDRESS_NAME_LABEL') | translate:{firstName:shipment?.pickupPointAddress?.firstName ?? '', lastName:shipment?.pickupPointAddress?.lastName ?? ''} }}</span>
                                <span>{{ shipment?.pickupPointAddress?.line1 }}</span>
                                <span>{{ shipment?.pickupPointAddress?.postalCode }} {{ shipment?.pickupPointAddress?.city }}</span>
                            </div>

                        </div>
                    } @else {
                        @if(order?.shippingAddress; as address) {
                            <div class="shipping-address">
                                <span class="title">{{ 'INVOICE.SHIPPING_ADDRESS_TITLE' | translate }}</span>
                                <div>

                                    <span>{{ address?.organizationName }}</span>
                                    <span>{{ (address?.organizationName?.length > 0 ? 'INVOICE.ADDRESS_ATT_LABEL' : 'INVOICE.ADDRESS_NAME_LABEL') | translate:{firstName:address?.firstName ?? '', lastName:address?.lastName ?? ''} }}</span>
                                    <span>{{ address?.line1 }}</span>
                                    <span>{{ address?.postalCode }} {{ address?.city }}</span>
                                    <span class="email">{{ address?.email }}</span>
                                </div>
                            </div>
                        }
                    }
                    <div class="shipping">
                        <span class="title">{{ 'INVOICE.SHIPPING_TITLE' | translate }}</span>
                        <div>
                            <span class="shipping-method">{{ shipment?.shippingMethodName }}</span>
                            <!-- <span class="shipping-extra"
                            *ngFor="let shipmentExtra of shipment?.shipmentServices">{{ shipmentExtra.shippingServiceName }}</span> -->
                        </div>
                    </div>
                }

            </section>
            <section class="order-lines">
                @if(order?.lines?.length > 0) {
                    <div class="titles">
                        <span>{{ 'BASKET.PRODUCT_NAME_LABEL' | translate }}</span>
                        <span></span>
                        <span class="center">{{ 'BASKET.QUANTITY_LABEL' | translate }}</span>
                        <span class="center">{{ 'BASKET.UNIT_PRICE_LABEL' | translate }}</span>
                        <span class="center">{{ 'BASKET.DISCOUNT_PRICE_LABEL' | translate }}</span>
                        <span class="center">{{ 'BASKET.TOTAL_PRICE_LABEL' | translate }}</span>
                    </div>
                    <div class="lines">
                        @for(line of order?.lines | parents; track line.id) {
                            <app-invoice-line class="line"
                                    [line]="line"
                                    [addons]="order?.lines| addons: line.id"></app-invoice-line>
                        }
                    </div>
                } @else {
                    <h1 class="message">{{ 'BASKET.EMPTY' | translate }}</h1>
                }
            </section>
            <section class="summary-section">
                <div class="terms-section">
                    <span class="title">{{ 'INVOICE.TERMS_TITLE' | translate }}</span>
                    <button type="button" class="title" (click)="openTerms()">{{ 'INVOICE.TERMS_BUTTON' | translate }}</button>
                    <dialog [modal]="true"
                            id="terms-modal">
                        <button closeDialog></button>
                        <div>
                            <layout-block-list-outlet [list]="termsLayout"></layout-block-list-outlet>
                        </div>
                    </dialog>
                </div>
                <app-basket-summary [basket]="order"></app-basket-summary>
            </section>
            <!-- <a class="checkout"
               [routerLink]="'/'">
               <span>{{ 'INVOICE.TO_FRONTPAGE' | translate }}</span>
               <app-svg use="arrow-right"></app-svg>
            </a> -->
        </div>
        <!-- <aside>
            <app-checkout-contact></app-checkout-contact>
            <app-checkout-hours-of-operation></app-checkout-hours-of-operation>
            <app-checkout-payment-cards></app-checkout-payment-cards>
        </aside> -->

} @else {
    <div></div>
    <span class="loading">
        <app-svg use="circle-loading"></app-svg>
        <button (click)="getOrder()">{{ 'INVOICE.RELOAD_ORDER' | translate }}</button>
    </span>
}
<div class="usp">
    <app-usp-bulk-element [layout]="checkout?.usp || []"></app-usp-bulk-element>
</div>

</div>
